import setTransition from './setTransition.js';
import transitionStart from './transitionStart.js';
import transitionEnd from './transitionEnd.js';
export default {
  setTransition,
  transitionStart,
  transitionEnd
};


//////////////////
// WEBPACK FOOTER
// /data/websites/sparkasse.it/httpdocs/wp-content/themes/g2k-sparkasse/sito-investor-relations/node_modules/swiper/core/transition/index.js
// module id = 101
// module chunks = 0